module.exports = __webpack_public_path__ + "static/media/femaledev.8a6cd053.png";